import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AllInOneService } from 'src/app/shared/services/all-in-one.service';
import { KunyekService } from 'src/app/shared/services/kunyek.service';
import { MessageService } from 'src/app/shared/services/message.service';
import { MemberPositionControlComponent } from '../member-position-control/member-position-control.component';

@Component({
  selector: 'app-member-info-sync-dialog',
  templateUrl: './member-info-sync-dialog.component.html',
  styleUrls: ['./member-info-sync-dialog.component.scss']
})
export class MemberInfoSyncDialogComponent implements OnInit {

  currentDate = new Date(Date.now());

  submitSyncLoading: boolean = false;
  gettingDepartmentList: boolean = false;
  orgid: string = '';

  generalDatePickerConfig = this.allinoneService.datePickerConfig;

  departmentList: any = [];

  syncForm: any = {
    startdate: this.currentDate,
    enddate: this.currentDate,
    department: '',
  };

  constructor(
    public allinoneService: AllInOneService,
    private kunyekService: KunyekService,
    private messageService: MessageService,
    public dialogRef: MatDialogRef<MemberPositionControlComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.orgid = data.orgid;
  }

  ngOnInit(): void {
    this.getDepartmentList();
  }

  getDepartmentList() {
    this.gettingDepartmentList = true;
    const data = { domain: this.orgid, accept_key: "DA8n3pB5DC39w1lF5B7B52dA2C68D" };
    this.kunyekService.getHxmDepartmentList(data).subscribe(
      (res: any) => {
        if (res.statuscode == 300) {
          this.departmentList = res.datalist || [];
        } else {
          this.messageService.openSnackBar(
            res.message || res.status || 'Server Error',
            'warn'
          );
        }
        this.gettingDepartmentList = false;
      },
      (err) => {
        this.gettingDepartmentList = false;
        this.messageService.openSnackBar('Server Error', 'warn');
      }
    );
  }

  submitSyncData() {
    this.submitSyncLoading = true;
    this.dialogRef.disableClose = true;
    var data = {
      startdate: this.allinoneService.parseDate(this.syncForm.startdate),
      enddate: this.allinoneService.parseDate(this.syncForm.enddate),
      orgid: this.orgid,
      department: this.syncForm.department,
    };
    
    console.log(data,'////')
    var fun = this.kunyekService.memberInfoSyncData(data);
    fun.subscribe(
      (res: any) => {
        console.log(res);
        if (res.returncode == '300') {
          this.submitSyncLoading = false;
          this.dialogRef.close();
          this.messageService.openSnackBar(
            'It can take up to 15 minutes to update the position control data.',
            'success'
          );
        } else {
          this.dialogRef.disableClose = false;
          this.submitSyncLoading = false;
          this.messageService.openSnackBar(
            res.status || res.message || 'Server Error',
            'warn'
          );
        }
      },
      (err) => {
        this.dialogRef.disableClose = false;
        this.submitSyncLoading = false;
        this.messageService.openSnackBar(err.status, 'warn');
      }
    );
  }

  checkDate() {
    if (this.syncForm.enddate < this.syncForm.startdate) {
      this.syncForm.enddate = this.syncForm.startdate;
    }
  }

}
